import axios from 'axios';

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;

let allCarrouselSlides = null;
let allInfoSections = null;
let allCategoriesSections = null;
let brandImageBrandUrl = "";
let brandImageFirmnessUrl = "";
let brandImageSizingUrl = "";

let brandImageDildoUrl = "";
let brandImageAccessoriesUrl = "";
let brandImageMerchandiseUrl = "";

async function fetchCarrousel() {
    try {
        const response = await axios.get(backendBaseUrl + "carrouselSlides/");
        allCarrouselSlides = response.data;
    }
    catch (error) {
        alert(error);
        allCarrouselSlides = [];
    }
}

async function fetchInfoSections() {
    try {
        const response = await axios.get(backendBaseUrl + "homeInfos/");
        allInfoSections = response.data;
    }
    catch (error) {
        alert(error);
        allInfoSections = [];
    }
}

async function fetchCategories(){
    try {
        const response = await axios.get(backendBaseUrl + "categories/");
        allCategoriesSections = response.data;
    }
    catch (error) {
        alert(error);
        allInfoSections = [];
    }
}

async function getAllCarouselSlides() {
    if (allCarrouselSlides == null){
        await fetchCarrousel();
    }
    allCarrouselSlides.sort((a, b) => a.orderId - b.orderId);
    return allCarrouselSlides;
}

async function getInfoImagesPerName() {
    if (allInfoSections == null){
        await fetchInfoSections();
    }
    let imageMap = new Map();

    for (const id in allInfoSections){
        imageMap.set(allInfoSections[id].name, {
            imageUrl: allInfoSections[id].imageUrl,
            imageUrlFR: allInfoSections[id].imageUrlFR
        });
    }
    
    brandImageBrandUrl = imageMap.get("brand-guide");
    brandImageFirmnessUrl = imageMap.get("firmness-guide");
    brandImageSizingUrl = imageMap.get("sizing-guide");
}

async function getCategoryImagesPerName() {
    if (allCategoriesSections == null){
        await fetchCategories();
    }
    
    let imageMap = new Map();
    for (const id in allCategoriesSections){
        imageMap.set(allCategoriesSections[id].name, {
            imageUrl: allCategoriesSections[id].imageUrl,
            imageUrlFR: allCategoriesSections[id].imageUrlFR
          });
    }

    brandImageDildoUrl = imageMap.get("Dildos");
    brandImageAccessoriesUrl = imageMap.get("Accessories");
    brandImageMerchandiseUrl = imageMap.get("Merchandise");
}

async function getAboutUsSectionImageUrl() {
    await getInfoImagesPerName();
    return brandImageBrandUrl;
}

async function getFirmnessSectionImageUrl() {
    await getInfoImagesPerName();
    return brandImageFirmnessUrl;
}


async function getSizingSectionImageUrl() {
    await getInfoImagesPerName();
    return brandImageSizingUrl;
}

async function getDildoSectionImageUrl() {
    await getCategoryImagesPerName();
    return brandImageDildoUrl;
}

async function getAccessoriesSectionImageUrl() {
    await getCategoryImagesPerName();
    return brandImageAccessoriesUrl;
}

async function getMerchandiseSectionImageUrl() {
    await getCategoryImagesPerName();
    return brandImageMerchandiseUrl;
}

export { getAllCarouselSlides, getInfoImagesPerName, getAboutUsSectionImageUrl, getFirmnessSectionImageUrl, getSizingSectionImageUrl, getDildoSectionImageUrl, getAccessoriesSectionImageUrl, getMerchandiseSectionImageUrl };
